// extracted by mini-css-extract-plugin
module.exports = {"trans-color":"loader--trans-color","component":"loader--component","wrap":"loader--wrap","text":"loader--text","spinner":"loader--spinner","spin":"loader--spin"};